import { RowInfo } from '../models/row-info';
import { ElementId } from './element-id-enum';

export const aRows = (): RowInfo[][] => [
  a1Rows(),
  a2Rows(),
  a3Rows(),
  a4Rows(),
];

const a1Rows = (): RowInfo[] => [
  {
    description: 'Verifica regolamentare',
    elements: [
      {
        description:
          'Partecipazioni in aziende appartenenti a settori non etici',
        id: ElementId.partecipazioniInAziendeAppartenentiASettoriNonEtici,
        kriWeight: 100,
      },
    ],
  },
];

const a2Rows = (): RowInfo[] => [
  {
    description: 'Verifica dati pubblici e status giuridico',
    elements: [
      {
        description: 'Dati e bilanci aggiornati',
        kriWeight: 100,
        id: ElementId.datiEBilanciAggiornati,
      },
      {
        description: "Assenza di criticità/negatività dell'impresa target",
        kriWeight: 100,
        id: ElementId.assenzaDiCriticitaNegativitaDellImpresaTarget,
      },
      {
        description:
          'Analisi di altre anomalie e centrale rischi negli ultimi 12 mesi',
        kriWeight: 100,
        id: ElementId.analisiDiAltreAnomalieECentraleRischiNegliUltimi12Mesi,
      },
      {
        description:
          'Accesso storico a procedure ristr.ne debiti e Status corrente in procedura o altra forma di ristr.ne debiti',
        kriWeight: 100,
        id: ElementId.accessoStoricoAProcedureRistrNeDebitiEStatusCorrenteInProceduraOAltraFormaDiRistrNeDebiti,
      },
    ],
  },

  {
    description: 'Open Banking',
    elements: [
      {
        description: "Ricezione autorizzazione all'Open Banking del Borrower",
        kriWeight: 100,
        id: ElementId.ricezioneAutorizzazioneAllOpenBankingDelBorrower,
      },
      {
        description: 'Verifica anomalie su Open Banking negli ultimi 3 mesi ',
        kriWeight: 100,
        id: ElementId.verificaAnomalieSuOpenBankingNegliUltimi3Mesi,
      },
    ],
  },

  {
    description: 'Controllo di gestione del Borrower*',
    elements: [
      {
        description:
          'Esistenza funzione di Controllo/Budgeting aggiornati in azienda',
        kriWeight: 100,
        id: ElementId.esistenzaFunzioneDiControlloBudgetingAggiornatiInAzienda,
      },
    ],
  },
];

const a3Rows = (): RowInfo[] => [
  {
    description: 'Verifica garanzia del Finanziamento (se presente)*',
    elements: [
      {
        description: 'Ipotecaria/Pegno/privilegio speciale',
        kriWeight: 100,
        id: ElementId.ipotecariaPegnoPrivilegioSpeciale,
      },
      {
        description: 'Garanzie Personali',
        kriWeight: 100,
        id: ElementId.garanziePersonali,
      },
      {
        description: 'Garanzie Di Antergazione Contrattuale O Giudiziale',
        kriWeight: 100,
        id: ElementId.garanzieDiAntergazioneContrattualeOGiudiziale,
      },
      {
        description: 'Garanzie atipiche',
        kriWeight: 100,
        id: ElementId.garanzieAtipiche,
      },
    ],
  },

  {
    description: 'Due Diligence*',
    elements: [
      {
        description: 'DD Immobiliare Aspetti tecnici',
        kriWeight: 100,
        id: ElementId.ddImmobiliareAspettiTecnici,
      },
      {
        description:
          'Aspetti di regolarità/conformità amministrativa/urbanistica',
        kriWeight: 100,
        id: ElementId.aspettiDiRegolaritaConformitaAmministrativaUrbanistica,
      },
      {
        description: 'DD legale su garanzie (personali o reali)',
        kriWeight: 100,
        id: ElementId.ddLegaleSuGaranziePersonaliOReali,
      },
    ],
  },
  {
    description: 'Analisi di progetti edificatori erigendi (opzionale)',
    elements: [
      {
        description:
          'Coerenza flussi di erogazione con stati avanzamento lavori',
        kriWeight: 100,
        id: ElementId.coerenzaFlussiDiErogazioneConStatiAvanzamentoLavori,
      },
      {
        description: 'Esistenza di contratti di preletting/presale',
        kriWeight: 100,
        id: ElementId.esistenzaDiContrattiDiPrelettingPresale,
      },
    ],
  },
];

const a4Rows = (): RowInfo[] => [
  {
    description: 'Settore',
    elements: [
      {
        description: '',
        kriWeight: 0,
        options: [
          {
            value: 'ALTRI SETTORI',
            view: 'ALTRI SETTORI',
          },
          {
            value: 'SETTORE IMMOBILIARE',
            view: 'SETTORE IMMOBILIARE',
          },
        ],
      },
    ],
  },
];
